import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveExperiments } from '../experiments/ExperimentUtils';
import { EndpointKey } from '../http/EndpointKey';
import { useRetryEndpoint } from '../http/useRetryEndpoint';
import { Metrics } from '../metrics/Metrics';
import { MetricsCounter } from '../metrics/MetricsCounter';
import { ErrorKey } from './ErrorKey';
import StandardError from './StandardError';

const StandardCreationError = () => {
  const dispatch = useDispatch();
  const errorKey = ErrorKey.StandardCreationError;
  const activeExperiments = useSelector(getActiveExperiments);
  const {
    retryEndpoint,
    isLoading,
    handleLoadingOnRetry
  } = useRetryEndpoint();
  useEffect(() => {
    Metrics.counter(MetricsCounter.StandardErrorCreation, activeExperiments).increment();
  }, [activeExperiments]);

  const onClick = event => {
    event.preventDefault();
    handleLoadingOnRetry(); // Adding a timeout for better chances of success in case of server unreliability

    dispatch(retryEndpoint(EndpointKey.Signup, 2200));
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    isButtonLoading: isLoading,
    onSentenceWithLinkClick: onClick
  });
};

export default StandardCreationError;